import { render, staticRenderFns } from "./socialBill.vue?vue&type=template&id=5d3fd3a2&scoped=true&"
import script from "./socialBill.vue?vue&type=script&lang=js&"
export * from "./socialBill.vue?vue&type=script&lang=js&"
import style0 from "./socialBill.vue?vue&type=style&index=0&id=5d3fd3a2&prod&lang=scss&scoped=true&"
import style1 from "./socialBill.vue?vue&type=style&index=1&id=5d3fd3a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fd3a2",
  null
  
)

export default component.exports